module.exports = __webpack_public_path__ + "img/362-0f56eb.png";